import React from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

const ThankYou = () => (
  <div data-testid="thankyou-page" className="min-h-[80vh] pt-[150px] pb-28 grid place-items-center">
    <div className="max-w-2xl mx-auto px-5 md:px-10 text-center">
      <motion.div
        initial={{ scale: 0, rotate: -20 }} animate={{ scale: 1, rotate: 0 }}
        transition={{ type: "spring", stiffness: 200, damping: 14 }}
        className="mx-auto grid place-items-center h-20 w-20 rounded-full bg-[#f4b41a] mb-8">
        <Check size={38} className="text-neutral-900" />
      </motion.div>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight">
        Thank you. We've got your requirement.
      </h1>
      <p className="mt-6 text-lg text-neutral-600">
        Our team will review your requirement and get back to you shortly with the right solution.
      </p>
      <div className="mt-10 flex flex-wrap justify-center gap-4">
        <Link to="/" className="rounded-full border border-neutral-300 hover:border-neutral-900 font-semibold px-7 py-4 transition-colors">Back to Home</Link>
        <Link to="/solutions" className="group inline-flex items-center gap-2 rounded-full bg-neutral-900 text-white font-semibold px-7 py-4 hover:bg-neutral-800 transition-colors">
          Explore Solutions <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
        </Link>
      </div>
    </div>
  </div>
);

export default ThankYou;
